import {  Grid, Button, IconButton} from '@material-ui/core';
import { Dialog, DialogTitle, DialogContent } from '@material-ui/core/';
import { makeStyles } from '@material-ui/core/styles';
import React, { useState ,useEffect} from 'react';
import CloseIcon from '@material-ui/icons/Close';
import StatusDisplay from './StatusDisplay'
import smsIcon from '../assets/Images/sms_mfa.png'
import authAppIcon from '../assets/Images/authenticator_app_mfa.png'
import emailIcon from '../assets/Images/email_mfa.png'

const useStyles = makeStyles((theme) => ({
    signinbtn: {
        fontFamily: 'Open Sans',
        fontWeight: 400,
        fontSize: 18,
        backgroundColor: "#1867B8",
        width: 160,
        height: 40,
        color: '#FFFFFF',
        margin: 20,
        borderRadius: 0,
        '&:hover': {
            backgroundColor: "#1867B8",
            color: '#FFFFFF',
        }

    }
}));

const MFASelectDialog = ( {open,signinlabel,okCallback,closeCallback , cognitoResult
        ,isRunning,successMessage,setSuccessMessage,error,setError} )=>{

    const classes = useStyles();
    let [sms, setSMS] = useState(false);
    let [authApp, setAuthApp] = useState(false);

        


    return (
        <Dialog fullWidth={true} open={open} maxWidth='sm' disableBackdropClick disableEscapeKeyDown >
            <Grid item xs={12} container>
                <Grid item xs={11}> <DialogTitle id="verify-authapp-user-dilaog">{signinlabel.SelectMFATitle}</DialogTitle> </Grid>
                <Grid item xs={1}> <IconButton onClick={()=>{closeCallback();}}> <CloseIcon /> </IconButton> </Grid>
            </Grid>
        <DialogContent style={{width:"800px;"}}>     
        <div style={{ marginBottom: '20px', marginLeft: '10px', marginRight: '10px', height: '340px', width: '520px' }}>
            <StatusDisplay isRunning={isRunning}  successMessage={successMessage} setSuccessMessage={setSuccessMessage} error={error} setError={setError} ></StatusDisplay>
            <div> {signinlabel.SelectMFADescription}</div>
            <div style={{marginTop:"15px", height:"80px"}}>
                    <img style={{float:"left"}} src={smsIcon} alt=""></img>
                    <input style={{margin:"20px",float:"left"}} type="radio" name="mfaType" value="SMS_MFA"  checked={sms} onChange={(e=>{ setSMS( e.target.checked) })}></input>
                    {signinlabel.SelectMFA_SMS}: {signinlabel.SelectMFA_SMSDescription}
            </div>  
            <hr></hr>
            <div style={{marginTop:"15px", height:"80px"}}>
                    <img style={{float:"left"}} alt="" src={authAppIcon} ></img>
                    <input style={{margin:"20px",float:"left"}} type="radio" name="mfaType" value="SOFTWARE_TOKEN_MFA" checked={authApp}  onChange={(e=>{ setAuthApp( e.target.checked) })} ></input>
                    {signinlabel.SelectMFA_APP}: {signinlabel.SelectMFA_APPDescription}
            </div>
            <hr></hr>
            <div><Button variant="contained" color="primary"  onClick={e=>{okCallback( sms?"SMS_MFA":"SOFTWARE_TOKEN_MFA");} } className={classes.signinbtn}> {signinlabel.SelectMFA_BUTTONLABEL} </Button></div>
        </div>                               
        </DialogContent>
    </Dialog>
    );
}
export default MFASelectDialog;